<template>
    <div class="loginman">
      <div class="Footnavbar">
        <div class="foot-in">
          <div class="l">
            <div class="help">
              <img class="icon" src="../../../assets/images/help.png" />
              <div class="p">
                <a
                  href="https://gkzpfw.com/static/help_manual.pdf"
                  target="_blank"
                  >帮助手册</a
                >
              </div>
            </div>

            <div class="help faq" @click="toFaq()">
              <img class="icon" src="../../../assets/images/faq.png" />
              <div class="p">
                <a>常见问题</a>
              </div>
            </div>

          </div>
          <div class="r">
            <div class="f-t">
              <span class="f-t1">报名期间（工作日）咨询时间:</span>
              <span class="f-t2">{{ linkTime }}<span style="margin: 0 15px;"></span
                >15:00-18:00</span
              >
            </div>
            <div class="f-t">
              <span class="f-t1">网上报名系统操作咨询:</span>
              <div style="display: flex;">
                <span class="f-t2">{{linktel}}</span>
              </div>
            </div>
          </div>
        </div>
        <span style="display: block;margin: 20px;">技术支持： 广西麒睿信息技术有限公司 ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank">桂ICP备17006471号</a></span>
      </div>
    </div>
</template>

<script>
import { fetchHelpList } from "@/api/help";
export default {
  name: "nvbar",
  data() {
    return {
      helpList: null,
      linkTime: process.env.LINKTIME,
      linktel: process.env.LINKTEL,
    };
  },
  components: {},
  created() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      // fetchHelpList().then((res) => {
      //   this.helpList = res.data;
      // });
    },
    toFaq(){
      let { href } = this.$router.resolve({ path: "/FAQ" });
      window.open(href, "_blank");
    },
    goto(item) {
      window.localStorage.setItem("HelpItem", JSON.stringify(item));
      let { href } = this.$router.resolve({ path: "/help" });
      window.open(href, "_blank");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/login_blue.scss";
</style>




// WEBPACK FOOTER //
// src/views/login/components/Foot.vue